import React from "react";
import {
  Container,
  Box,
  HStack,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import "./styles.css";

const roadmaps = [
  {
    heading: "CROWDFUND",
    text: "First community crowdfund and whitepaper is launched on mirror.xyz, with first 1000 NFTs up for grabs. Drop #1 with a minting price of 0.04 ETH for the lucky few.",
  },
  {
    heading: "PRESALE",
    text: "Drop #2 is scheduled to kick-off in the first half of April 2022. A total of 3000 NFTs will be offered, with 250 NFT mint passes used for giveaways, marketing, promotions, and influencercollaborations. Mint price will be significantly higher than Drop #1, with the exact amount TBD.",
  },
  {
    heading: "PUBLIC SALE",
    text: "The final Drop #3 date will be scheduled right before the start of our free high-rollertournament series for NFT holders. Launch date is planned for the end Q2 2022 and will beannounced separately. The remaining supply of 5500 NFTs will be available to mint, with 500pcs reserved for further marketing promotions and charity giveaways.",
  },
  {
    heading: "LET THE GAME BEGIN!",
    text: "Once NFT distribution is complete we will conduct a celebratory series of tournaments to reward our supporters. Prize fund of $300,000 will be distributed among the 10-15% of lucky winners. This will mark the beginning of Phase 2 of Marbleverse project, with paid tournaments going live shortly after.Turning to the next chapter, our team will devote its full attention towards achieving further roadmap milestones. Focusing on the product, promoting the game and attracting new playerswill be our top priorities going forward. Furthermore, 50% of all revenue generated by Marbleverse project will accrue to the core community, driving higher the value of NFTs in thelong run. For details please refer to the whitepaper and join our Discord for further questions.",
  },
];

function index() {
  return (
    <Container maxW="container.xl" mb={32} id="roadmap">
      <Box w="100%" h={{ base: "220vh", md: "100vh" }} id="container">
        <VStack spacing={16} w="100%" h="100%">
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            ROADMAP
          </Heading>
          <VStack w="100%" spacing={0} h="100%">
            {roadmaps.map(({ heading, text }, index) => (
              <Blocks key={text} heading={heading} text={text} index={index} />
            ))}
          </VStack>
        </VStack>
      </Box>
    </Container>
  );
}

const Blocks = ({ heading, text, index }) => {
  return (
    <HStack alignItems="flex-start" spacing={10} h="auto">
      <VStack spacing={0} w="70px" height="100%">
        <Box
          borderRadius="10px"
          // w="70px"
          height="50px"
          w="70px"
          backdropFilter="blur(5px) brightness(100%) "
          bg="radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, .15) 24.48%, rgba(255, 255, 255, .25) 100%)"
          textAlign={"center"}
          lineHeight="50px"
          flex={1}
        >
          <Text fontSize="xl">{index + 1}</Text>
        </Box>
        <Box
          // flex={3}
          // display="block"
          height="100%"
          w="4px"
          // backgoundImage="linear-gradient(180deg,#947526,#cfcfcf 58%,#d3cfa3)"
          id="lines"
        >
          {/* sthstehaehsehsethseth */}
        </Box>
      </VStack>

      <VStack
        w="100%"
        spacing={5}
        justifyContent="center"
        alignItems="flex-start"
        px={{ base: 0, md: 14 }}
      >
        <Text
          fontSize="xl"
          textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)"
          py={3}
        >
          {heading}
        </Text>
        <Text
          fontWeight="500"
          pr={5}
          textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)"
        >
          {text}
        </Text>
      </VStack>
    </HStack>
  );
};

export default index;
